<template>
  <div class="text-left">
    <ValidationObserver v-slot="{}" ref="createForm">
      <ValidationProvider name="ruleVersion" rules="required" v-slot="{ errors }">
        <div class="mb-3">
          <!-- <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]"> -->
          <label>{{ $t("orderRules.ruleVersion") }}</label>
          <!-- <md-input v-model="post.ruleVersion" type="text"> </md-input> -->
          <div>
            <md-radio v-model="post.ruleVersion" value="SQP-Split">SQP-Split</md-radio>
            <md-radio v-model="post.ruleVersion" value="CAB-Merge">CAB-Merge</md-radio>
          </div>
          <div class="md-error" v-if="errors[0]">
            {{ $t(errors[0]) }}
          </div>
          <!-- </md-field> -->
        </div>
      </ValidationProvider>
      <div class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
        <ul style="list-style: none">
          <li style="text-align: left" v-for="s in post.skus" :key="s.sku">
            <strong>{{ s.sku }} ({{ s.quantity }})</strong>
            <span @click="removeSku(s.sku)"><md-icon>delete</md-icon></span>
          </li>
        </ul>
        <div style="text-align: left; color: #4caf50 !important; cursor: pointer">
          <span @click="addManualSkuModal = true">{{ $t("orders.addSku") }}</span>
        </div>
      </div>

      <div class="text-right gap-1">
        <md-button class="md-secondary mr-1" @click="handleCancel">{{ $t("news.cancel") }}</md-button>
        <md-button class="md-success mr-1" @click="savePost">{{ $t("news.save") }}</md-button>
      </div>
    </ValidationObserver>

    <modal v-if="addManualSkuModal" @close="hideAddManualSkuModal" class-name="orders-modal-container">
      <template slot="header">
        <h4 class="modal-title">{{ $t("orders.addSku") }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideAddManualSkuModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <md-field>
          <label for="skuQuantity">{{ $t("orders.quantity") }}</label>
          <md-input v-model="skuQuantity" type="sku"></md-input>
        </md-field>

        <div class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
          <label>{{ $t("wms.sku") }}</label>
          <v-select
            :loading="loadingSku"
            label="sku"
            :reduce="(item) => item.sku ?? item"
            :options="skuOptions"
            :filter="fuseSearchSKU"
            :placeholder="$t('wms.sku')"
            class="custom-select"
            @input="onSelectInventory"
          >
            <template slot="no-options"> {{ $t("noRecord") }} </template>

            <template slot="option" slot-scope="option">
              <div :class="`d-center ${option.exact ? 'exact' : ''}`" v-html="option.sku"></div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center" v-html="option.sku"></div>
            </template>
          </v-select>
        </div>
        <div class="text-right gap-1">
          <md-button class="md-secondary mr-1" @click="hideAddManualSkuModal">{{ $t("orders.close") }}</md-button>
          <md-button class="md-success" @click="addManualSku">{{ $t("orders.save") }}</md-button>
        </div>
      </template>
      <template slot="footer"> </template>
    </modal>
  </div>
</template>

<script>
import Fuse from "fuse.js";
import ordersService from "../../services/orders.service";
import { Modal } from "@/components";

export default {
  components: {
    Modal,
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      post: this.data
        ? structuredClone(this.data)
        : {
            ruleVersion: "SQP-Split",
            skus: [],
          },
      errors: {},
      isLoading: false,
      products: [],
      loadingSku: false,
      addManualSkuModal: false,
      skuSelected: { value: null, sku: null, name: "SKU" },
      skuQuantity: null,
      inventories: [],
    };
  },
  computed: {
    skuOptions() {
      return this.$store.state.shippingData.productSKUs?.map((p) => ({ value: p.sku, sku: p.sku, name: p.name })) || [];
    },
  },
  methods: {
    hideAddManualSkuModal() {
      this.addManualSkuModal = false;
    },
    handleCancel() {
      this.$emit("cancel");
    },
    savePost() {
      if (this.post.id) {
        this.updatePost();
      } else {
        this.createPost();
      }
    },
    createPost() {
      this.$refs.createForm.validate().then((success) => {
        if (!success) {
          return;
        }

        const formData = this.post;
        this.isLoading = true;
        ordersService
          .createRule(formData)
          .then(() => {
            this.$emit("post-created");
          })
          .catch(() => {
            this.$notify({
              timeout: 2500,
              message: this.$t("orderRules.messages.error"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error",
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    updatePost() {
      this.$refs.createForm.validate().then((success) => {
        if (!success) {
          return;
        }

        const formData = this.post;
        this.isLoading = true;
        ordersService
          .updateRule(formData)
          .then(() => {
            this.$emit("post-updated");
          })
          .catch(() => {
            this.$notify({
              timeout: 2500,
              message: this.$t("orderRules.messages.error"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error",
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    fuseSearchSKU(_options, search) {
      const fuse = new Fuse(_options, {
        keys: ["value"],
        shouldSort: true,
        minMatchCharLength: 2,
        includeMatches: true,
        threshold: 0,
      });
      const res = search.length
        ? fuse.search(search).map((pr) => {
            const { item } = pr;
            if (item.sku.toLowerCase() === search.toLowerCase()) {
              return { ...item, exact: true };
            } else {
              return { ...item };
            }
          })
        : fuse.list;

      return res;
    },
    addManualSku() {
      if (this.skuSelected && this.skuSelected.value && this.skuQuantity > 0) {
        this.post.skus.push({ sku: this.skuSelected.value, quantity: this.skuQuantity });
        this.skuQuantity = null;
        this.skuSelected = null;
        this.addManualSkuModal = false;
      } else {
        this.$notify({
          timeout: 2500,
          message: this.$t("orders.selectSku"),
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "error",
        });
      }
    },
    removeSku(sku) {
      this.post.skus = this.post.skus.filter((s) => s.sku !== sku);
    },
    onSelectInventory(selected) {
      if (!selected) {
        return;
      }
      this.skuSelected = { value: selected };
    },
  },
  created() {},
};
</script>
<style lang="scss"></style>
